import React from 'react'
import Routes from 'core/components/Routes'

import { GlobalProvider } from 'core/contexts/global-context'

const App = (props) => {
  return (
    <div className="app">
      <GlobalProvider>
        <Routes />
      </GlobalProvider>
    </div>
  )
}

export default App
